var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputComponent',_vm._g(_vm._b({attrs:{"mask":{
    mask: '0000/000/0000/00/00',
    lazy: false,
    placeholderChar: '-',
  },"label":_vm.label},model:{value:(_vm.comp),callback:function ($$v) {_vm.comp=$$v},expression:"comp"}},'InputComponent',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }